import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Phone, Mail, MapPin } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigationLinks = [{
    label: "Start",
    href: "/HomePage"
  }, {
    label: "Leistungen",
    href: "/ServicesPage"
  }, {
    label: "Referenzen",
    href: "/ReferencesPage"
  }, {
    label: "Über uns",
    href: "/AboutUsPage"
  }, {
    label: "Kontakt",
    href: "/ContactPage"
  }];
  const services = ["Gebäudeautomation", "Energieoptimierung", "Wago SPS Steuerungstechnik", "Loxone Partner"];
  return <footer id="footer" className="dark bg-background text-foreground py-16 pb-8 border-t border-border/10" style={{
    "--primary": "215 95% 50%",
    "--primary-100": "215 95% 95%",
    "--primary-500": "215 95% 50%",
    "--primary-900": "215 95% 10%",
    "--secondary": "30 40% 45%",
    "--background": "220 10% 8%",
    "--foreground": "210 20% 98%",
    "--muted": "220 10% 14%",
    "--muted-foreground": "210 15% 70%",
    "--border": "220 15% 25%",
    "--accent": "215 80% 70%",
    "--card": "220 10% 12%",
    "--popover": "220 10% 14%",
    "--ring": "215 95% 50%"
  } as React.CSSProperties}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://s2automation.ch/wp-content/uploads/2026/06/S2_logo_clean_HD_cropped.png" alt="S2 Automation" className="h-20 w-auto object-contain hover:filter-none" />
            </Link>
            <div className="flex flex-col gap-4 text-sm text-muted-foreground">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-primary" />
                <span>
                  S2 Automation
                  <br />
                  Oberwallis, Schweiz
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-semibold text-foreground tracking-tight">
              Navigation
            </h3>
            <nav className="flex flex-col gap-3">
              {navigationLinks.map((link, i) => <Link key={i} data-index={i} to={link.href} className="text-sm text-muted-foreground hover:text-primary transition-colors w-fit">
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-semibold text-foreground tracking-tight">
              Leistungen
            </h3>
            <nav className="flex flex-col gap-3">
              {services.map((service, i) => <Link key={i} data-index={i} to="/ServicesPage" className="text-sm text-muted-foreground hover:text-primary transition-colors w-fit">
                  {service}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-semibold text-foreground tracking-tight">
              Kontakt
            </h3>
            <div className="flex flex-col gap-4">
              <Link to="tel:+41774417863" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-primary transition-colors w-fit group">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-secondary/50 group-hover:bg-primary/10 transition-colors">
                  <Phone className="w-4 h-4" />
                </div>
                <span>+41 77 441 78 63</span>
              </Link>
              <Link to="mailto:info@s2automation.ch" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-primary transition-colors w-fit group">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-secondary/50 group-hover:bg-primary/10 transition-colors">
                  <Mail className="w-4 h-4" />
                </div>
                <span>info@s2automation.ch</span>
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-border/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground/60">
          <p>© {currentYear} S2 Automation. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-2">
            <Link to="#" className="hover:text-primary transition-colors">
              Datenschutz
            </Link>
            <span className="w-1 h-1 rounded-full bg-muted-foreground/40" />
            <Link to="#" className="hover:text-primary transition-colors">
              Impressum
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}